import { TimeFrameValue } from '@givelify/utils';
import {
    MESSAGE_FILTER_VALUE,
    TRANSACTION_FILTER_VALUE,
} from '../../../models';
import { getDonationQuery } from '../../../queries';

export const DoneesEndpoints = {
    donee: () => `/donee`,
    donees: (doneeId: number) => `/donees/${doneeId}`,
    bankAccounts: (doneeId: number) => `/donees/${doneeId}/bank-accounts`,
    bankInfo: (doneeId: number) => `/donees/${doneeId}/bank-info`,
    beneficiary: (doneeId: number) => `/donees/${doneeId}/beneficiary`,
    quickGive: (doneeId: number) => `/donees/${doneeId}/quickgive`,
    donor: (doneeId: number, donorId: string) =>
        `/donees/${doneeId}/donors/${donorId}`,
    donors: (doneeId: number) => `/donees/${doneeId}/donors`,
    donations: (
        doneeId: number,
        timeFrame: TimeFrameValue,
        transactionFilter: TRANSACTION_FILTER_VALUE,
        envelopeIds: number[],
        pageNumber?: number,
        messageFilter?: MESSAGE_FILTER_VALUE[],
        sort?: string,
        search?: string,
        order?: string,
    ) =>
        `/donees/${doneeId}/donations${getDonationQuery({
            timeFrame,
            transactionFilter,
            page: pageNumber,
            envelopeIds,
            messageFilter,
            search,
            sort,
            order,
        })}`,
    donationsRefunded: (
        doneeId: number,
        timeFrame: TimeFrameValue,
        envelopeIds: number[],
        pageNumber: number,
        messageFilter?: MESSAGE_FILTER_VALUE[],
    ) =>
        `/donees/${doneeId}/donations${getDonationQuery({
            timeFrame,
            envelopeIds,
            messageFilter,
            page: pageNumber,
            transactionFilter: TRANSACTION_FILTER_VALUE.REFUNDED,
        })}`,
    deposits: (
        doneeId: number,
        timeFrame: TimeFrameValue,
        transactionFilter?: TRANSACTION_FILTER_VALUE,
        onlyDate?: boolean,
        pageNumber?: number,
    ) =>
        `/donees/${doneeId}/deposits${getDonationQuery({
            timeFrame,
            transactionFilter,
            page: pageNumber,
            onlyDate,
        })}`,
    faithLeader: (id: number) => `/donees/${id}/faith-leader`,
    givingLink: (doneeId: number) => `/donees/${doneeId}/giving-link`,
    integrationStats: (doneeId: number) =>
        `/donees/${doneeId}/integration/stats`,
    integrationDetails: (doneeId: number) =>
        `/donees/${doneeId}/integration/details`,
    integrationRegistration: (doneeId: number) =>
        `/donees/${doneeId}/integration/registration`,
    scheduledReports: (doneeId: number) =>
        `/donees/${doneeId}/scheduled-reports`,
    scheduledReport: (doneeId: number, scheduledReportId: number) =>
        `/donees/${doneeId}/scheduled-reports/${scheduledReportId}`,
    integrationExportedDonations: (
        doneeId: number,
        page: number,
        size: number,
    ) =>
        `/donees/${doneeId}/integration/exported-donations?page=${page}&per_page=${size}`,
    integrationExportedDonationsDownload: (
        doneeId: number,
        startDate: string,
        endDate: string,
    ) =>
        `/donees/${doneeId}/integration/exported-donations/download?start_date=${startDate}&end_date=${endDate}`,
    uploadImage: (doneeId: number) => `/donees/${doneeId}/images`,
    representatives: (doneeId: number) => `/donees/${doneeId}/representatives`,
    donationsLifetimeStatistics: (doneeId: number) =>
        `/donees/${doneeId}/donations/statistics/lifetime`,
    storeBookedMeetingDetails: () => `/calendly/store-meeting`,
    getBookedMeetingDetails: () => `/calendly/scheduled-events`,
};
